// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-slot-table .yxt-table .cell{display:flex;align-items:center}.lc-am-slot-table .yxt-table__row{pointer-events:unset!important}.lc-slot-table-edit-area{width:100%}", ""]);
// Exports
module.exports = exports;
